var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"max-w-xl"},[_c('CustomerForm',{attrs:{"errors":_vm.errors},on:{"submit":_vm.storeCustomer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }